import { Linkedin, ArrowRight } from "lucide-react";
import { FadeIn } from "./FadeIn";

const CALENDLY = "https://calendly.com/katie-fernands/discovery-call";
import erinAsset from "@/assets/erin.webp.asset.json";
import davidAsset from "@/assets/david.webp.asset.json";

export function Testimonials() {
  return (
    <section id="testimonials" className="bg-background py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="flex items-center gap-4 mb-10">
          <span className="text-xs uppercase tracking-[0.28em] text-primary">Testimonials</span>
          <span className="h-px flex-1 bg-foreground/15" />
          <span className="text-xs tracking-[0.2em] text-foreground/70">II</span>
        </div>

        {/* Featured quote */}
        <FadeIn>
          <figure className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            <div className="lg:col-span-3 flex lg:flex-col items-center lg:items-start gap-5">
              <div className="photo-ring">
                <img
                  src={davidAsset.url}
                  alt="David Gutzke"
                  loading="lazy"
                  className="h-24 w-24 lg:h-32 lg:w-32 rounded-full object-cover photo-edit hover:photo-edit-hover"
                />
              </div>
              <div>
                <p className="font-medium text-foreground">David Gutzke</p>
                <p className="text-sm text-muted-foreground mt-1">
                  Executive Director, Family Office Advisor, Wells Fargo
                </p>
                <a
                  href="https://www.linkedin.com/in/davegutzke/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="David Gutzke on LinkedIn"
                  className="inline-flex mt-3 text-muted-foreground hover:text-primary transition-colors"
                >
                  <Linkedin className="h-4 w-4" />
                </a>
              </div>
            </div>
            <blockquote className="lg:col-span-9">
              <span className="text-primary text-6xl md:text-7xl leading-none font-serif italic block -mb-4">&ldquo;</span>
              <p className="text-2xl md:text-4xl leading-[1.25] tracking-tight font-normal text-foreground">
                Katie educated me and worked with me on how social media and the financial world
                intersect. She's really pleasant to work with.
              </p>
            </blockquote>
          </figure>
        </FadeIn>

        {/* Supporting quote */}
        <FadeIn delay={0.15}>
          <figure className="mt-16 lg:mt-20 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start border-t border-foreground/15 pt-12">
            <div className="lg:col-span-9 lg:col-start-1">
              <p className="text-xl md:text-2xl leading-relaxed text-foreground/85 italic">
                When my team identified friction points across the digital experience, she translated
                those insights into messaging and content that directly addressed what customers were
                struggling with.
              </p>
            </div>
            <div className="lg:col-span-3 flex lg:flex-col items-center lg:items-start gap-5">
              <div className="photo-ring">
                <img
                  src={erinAsset.url}
                  alt="Erin Record"
                  loading="lazy"
                  className="h-20 w-20 rounded-full object-cover photo-edit hover:photo-edit-hover"
                />
              </div>
              <div>
                <p className="font-medium text-foreground">Erin Record</p>
                <p className="text-sm text-muted-foreground mt-1">Senior Leader UX/CX</p>
                <p className="text-sm text-muted-foreground">Prudential, Nationwide</p>
                <a
                  href="https://www.linkedin.com/in/erinrecord/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Erin Record on LinkedIn"
                  className="inline-flex mt-3 text-muted-foreground hover:text-primary transition-colors"
                >
                  <Linkedin className="h-4 w-4" />
                </a>
              </div>
            </div>
          </figure>
        </FadeIn>

        <FadeIn delay={0.2}>
          <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href={CALENDLY}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:opacity-90 transition-opacity"
            >
              Book a 30-minute call
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href="mailto:katie@katiefernands.com?subject=Advisor%20growth%20question"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors border-b border-foreground/20 hover:border-foreground pb-1"
            >
              Or send a question first
            </a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
